export default __webpack_public_path__ + "static/media/mergeAccountsFirstCardIcon.b0224103.svg";